export enum ApplyProcessActionTypes {
  CheckPrescreenShortPageOffer = 'applyProcess/checkPrescreenShortPageOffer',
  SubmitMailOffer = 'applyProcess/submitMailOffer',
  CheckExistingApplication = 'applyProcess/checkExistingApplication',
  RunPreliminaryCheck = 'applyProcess/runPreliminaryCheck',
  CheckExistingBorrower = 'applyProcess/checkExistingBorrower',
  CreateBorrower = 'applyProcess/createBorrower',
  UpdateBorrower = 'applyProcess/updateBorrower',
  CreateApplication = 'applyProcess/createApplication',
  CheckExistingAccount = 'applyProcess/checkExistingAccount',
  CreateAccount = 'applyProcess/createAccount',
  BorrowerStateCheck = 'applyProcess/borrowerStateCheck',
  RunSnowflakeShortPageDMCheck = 'applyProcess/runSnowflakeShortPageDMCheck',
  RunSnowflakePrescreenedOfferQuery = 'applyProcess/runSnowflakePrescreenedOfferQuery',
  RunSnowflakeZipCodeCheck = 'applyProcess/runSnowflakeZipCodeCheck',
  RunSnowflakePrescreenedOfferCheck = 'applyProcess/runSnowflakePrescreenedOfferCheck',
  RunSnowflakeBranchIdMismatchCheck = 'applyProcess/runSnowflakeBranchIdMismatchCheck',
  RunSnowflakeBorrowerStatusCheck = 'applyProcess/runSnowflakeBorrowerStatusCheck',
  RunGpsCheck = 'applyProcess/runGpsCheck',
  RunSummitLeadIntegrationDMStrategy = 'applyProcess/runSummitLeadIntegrationDMStrategy',
  CreateGoogleAssessment = 'applyProcess/createGoogleAssessment',
}
